import React from "react";

function CommercialPlaceHolderIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="59"
      fill="none"
      viewBox="0 0 50 59"
    >
      <rect
        width="49.105"
        height="58.584"
        fill="#1C64F2"
        fillOpacity="0.08"
        rx="8"
      ></rect>
      <path
        stroke="#1C64F2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M26.12 22.398c-.586.498-1.303.791-2.077.791-1.977 0-3.58-1.912-3.58-4.271 0-2.36 1.602-4.272 3.58-4.272 1.282 0 2.406.804 3.039 2.011m-8.666 20.064h2.67c.349 0 .695.05 1.033.149l2.821.818c.612.177 1.25.195 1.869.051l3.12-.724c.824-.191 1.582-.662 2.176-1.351l2.207-2.562c.63-.73.63-1.915 0-2.647-.567-.658-1.466-.733-2.108-.174L29.63 32.52a1.94 1.94 0 01-1.277.494H25.87h1.58c.892 0 1.614-.838 1.614-1.872v-.374c0-.86-.504-1.608-1.221-1.816l-2.44-.708a4.353 4.353 0 00-1.214-.172c-.987 0-2.773.974-2.773.974l-3 1.497M32.74 20.138c0 2.36-1.603 4.272-3.58 4.272-1.978 0-3.581-1.913-3.581-4.272s1.603-4.272 3.58-4.272c1.978 0 3.58 1.913 3.58 4.272zm-18.415 9.886v7.08c0 .683 0 1.025.112 1.285.098.23.254.417.447.534.219.133.505.133 1.078.133h.818c.573 0 .86 0 1.079-.133.192-.117.349-.304.447-.534.111-.26.111-.602.111-1.286v-7.079c0-.683 0-1.025-.111-1.286a1.142 1.142 0 00-.447-.534c-.22-.133-.506-.133-1.079-.133h-.818c-.573 0-.86 0-1.078.133a1.142 1.142 0 00-.447.534c-.112.26-.112.603-.112 1.286z"
      ></path>
    </svg>
  );
}

export default CommercialPlaceHolderIcon;
